import React, { useEffect, useState, useMemo, Fragment } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay } from 'swiper/modules';

import { Box, Grid, Skeleton, Typography } from '@mui/material';
import PopularGiftCard from '../PopularGiftCard';
import { useSelector } from 'react-redux';
import "./style.css"
const Index = ({ showTitle = true }) => {
    const [loading, setLoading] = useState(true);
    const allProducts = useSelector((state) => state.AllProducts.allData.slice(0, 60));

    // Define the function outside the component to prevent recreation on each render
    const maxDiscountProducts = useMemo(() => {
        return [...allProducts].sort((a, b) => b.discount - a.discount);
    }, [allProducts]);

    useEffect(() => {
        // This effect only runs when allProducts change
        if (allProducts.length > 0) {
            setLoading(false);
        }
    }, []);

    return (
        <Grid container sx={{
            mb: 0,
            py: {
                sm: "2rem",
            },
            borderRadius: 2,
            backgroundColor: "white.main",
        }}>
            {showTitle && <Grid item md={12} >
                <Typography
                    variant="h3"
                    color="dark.main"
                    sx={{
                        fontSize: { sm: "14.5px", md: "16px", lg: "24px", xl: "24px" },
                        textTransform: "capitalize",
                        color: { sm: "primary.main" },
                        mb: "10px",
                        ml: "10px",
                    }}
                >

                    Top Discounted Products
                </Typography>
            </Grid>}

            <Grid item md={12} sx={{
                overflow: "hidden",
                // mb: { xs: "40px", xl: "20px" },
                minHeight: { sm: 162, md: 163, lg: 167, xl: 167 }
            }}>
                <Swiper
                    slidesPerView="auto"
                    spaceBetween={10}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay]}
                >

                    {loading && !maxDiscountProducts.length ? <Box sx={{ display: "flex", flexDirection: "row" }}>
                        {Array.from({ length: 8 }).map((_, index) => (
                            <Fragment key={`md-product-card-index-${index * 1}`}>
                                <Box width={160} height={150}
                                    sx={{ boxShadow: 2, borderRadius: 2, mx: 1, my: 2 }}>
                                    <Skeleton variant="rectangular" width="100%"
                                        height="70px" sx={{ borderRadius: 2 }} />
                                    <Box sx={{ mx: 2, mt: 2 }}>
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" />
                                    </Box>
                                </Box>
                            </Fragment>
                        ))}
                    </Box>
                        :
                        maxDiscountProducts?.map((item) => (
                            <SwiperSlide key={item.id}>
                                <PopularGiftCard productData={item} />
                            </SwiperSlide>
                        ))
                    }

                </Swiper>
            </Grid>
        </Grid>
    );
}

export default Index;
